var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#DD2736"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1079:9098)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.78065 6.47629C6.57025 6.47629 6.39969 6.64685 6.39969 6.85724V13.5239C6.39969 13.7343 6.57025 13.9049 6.78065 13.9049H13.4473C13.6577 13.9049 13.8283 13.7343 13.8283 13.5239V6.85724C13.8283 6.64685 13.6577 6.47629 13.4473 6.47629H6.78065ZM5.25684 6.85724C5.25684 6.01567 5.93907 5.33344 6.78065 5.33344H13.4473C14.2889 5.33344 14.9711 6.01567 14.9711 6.85724V13.5239C14.9711 14.3655 14.2889 15.0477 13.4473 15.0477H6.78065C5.93907 15.0477 5.25684 14.3655 5.25684 13.5239V6.85724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25684 8.76204C5.25684 8.44645 5.51267 8.19061 5.82826 8.19061H14.3997C14.7153 8.19061 14.9711 8.44645 14.9711 8.76204C14.9711 9.07763 14.7153 9.33347 14.3997 9.33347H5.82826C5.51267 9.33347 5.25684 9.07763 5.25684 8.76204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0192 4.38098C12.3348 4.38098 12.5906 4.63682 12.5906 4.95241V6.85717C12.5906 7.17276 12.3348 7.4286 12.0192 7.4286C11.7036 7.4286 11.4478 7.17276 11.4478 6.85717V4.95241C11.4478 4.63682 11.7036 4.38098 12.0192 4.38098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.20961 4.38098C8.5252 4.38098 8.78104 4.63682 8.78104 4.95241V6.85717C8.78104 7.17276 8.5252 7.4286 8.20961 7.4286C7.89402 7.4286 7.63818 7.17276 7.63818 6.85717V4.95241C7.63818 4.63682 7.89402 4.38098 8.20961 4.38098Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1079:9098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.4286,
    height: 11.4286,
    fill: "white",
    transform: "translate(4.3999 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.84588f23e7d5084b25d06f4f200a32a0.svg";
export { ForwardRef as ReactComponent };